import React from 'react';
import { Link } from 'react-router-dom';
import { FaMapMarkerAlt, FaClock } from 'react-icons/fa';

const Destinations = () => {
  const destinations = [
    {
      category: "The Capital City",
      title: "Addis Ababa",
      description: "Ethiopia's vibrant capital, home to the National Museum, Merkato market, and rich cultural heritage.",
      image: "/images/addis-ababa.jpg",
      tours: 8,
      link: "/destinations/addis-ababa"
    },
    {
      category: "Historic Monastery",
      title: "Debre Libanos",
      description: "Visit the famous monastery, Portuguese Bridge, and breathtaking Blue Nile Gorge.",
      image: "/images/debre-libanos.jpg",
      tours: 3,
      link: "/destinations/debre-libanos"
    },
    {
      category: "UNESCO World Heritage",
      title: "Lalibela",
      description: "Explore 11 medieval rock-cut churches carved from living stone.",
      image: "/images/lalibela.jpg",
      tours: 5,
      link: "/destinations/lalibela"
    },
    {
      category: "Living Cultures",
      title: "Omo Valley",
      description: "Meet indigenous tribes with ancient traditions still alive today.",
      image: "/images/omo-valley.jpg",
      tours: 6,
      link: "/destinations/omo-valley"
    },
    {
      category: "Alien Landscapes",
      title: "Danakil Depression",
      description: "Witness Earth's most extreme and colorful volcanic terrain.",
      image: "/images/danakil.jpg",
      tours: 4,
      link: "/destinations/danakil"
    },
    {
      category: "Nature & Wildlife",
      title: "Bale Mountains",
      description: "Trek through dramatic peaks and spot endemic wildlife like the Ethiopian Wolf.",
      image: "/images/bale.jpg",
      tours: 5,
      link: "/destinations/bale-mountains"
    },
    {
      category: "Historic North",
      title: "Gondar",
      description: "Explore the 'Camelot of Africa' with its medieval castles and churches.",
      image: "/images/gondar.jpg",
      tours: 4,
      link: "/destinations/gondar"
    },
    {
      category: "Ancient City",
      title: "Axum",
      description: "Discover the ancient capital with its towering obelisks and archaeological sites.",
      image: "/images/axum.jpg",
      tours: 3,
      link: "/destinations/axum"
    },
    {
      category: "Lake Region",
      title: "Bahir Dar",
      description: "Visit Lake Tana's island monasteries and the spectacular Blue Nile Falls.",
      image: "/images/bahir-dar.jpg",
      tours: 4,
      link: "/destinations/bahir-dar"
    }
  ];

  return (
    <div className="bg-white">
      {/* HERO SECTION */}
      <section 
        className="relative bg-cover bg-center text-white py-32 md:py-40"
        style={{
          backgroundImage: `linear-gradient(rgba(14, 124, 124, 0.85), rgba(11, 94, 94, 0.9)), url('/images/destinations-hero.jpg')`,
          marginTop: '-80px',
          paddingTop: '120px'
        }}
      >
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4">Explore Ethiopia</h1>
          <p className="text-xl md:text-2xl max-w-3xl mx-auto text-white/90">
            From ancient rock churches to otherworldly volcanic landscapes, Ethiopia offers experiences unlike anywhere else on Earth.
          </p>
        </div>
      </section>
      
      {/* DESTINATIONS GRID */}
      <section className="py-20 md:py-24">
        <div className="container mx-auto px-4 max-w-7xl">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {destinations.map((dest, i) => (
              <Link 
                key={i}
                to={dest.link}
                className="group bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 border border-gray-100"
              >
                <div className="h-56 bg-cover bg-center group-hover:scale-105 transition-transform duration-500" 
                     style={{ backgroundImage: `url(${dest.image})` }}>
                </div>
                <div className="p-6">
                  <p className="text-sm font-semibold text-[#0e7c7c] uppercase tracking-wider mb-2">{dest.category}</p>
                  <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-[#0b5e5e] transition-colors">
                    {dest.title}
                  </h3>
                  <p className="text-gray-600 text-sm mb-4">{dest.description}</p>
                  <div className="flex items-center justify-between">
                    <span className="text-sm text-gray-500">{dest.tours} tours available</span>
                    <span className="text-[#0e7c7c] font-semibold text-sm">Explore →</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
      
      {/* CTA SECTION */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4 max-w-4xl text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">Can't Decide Where to Go?</h2>
          <p className="text-lg text-gray-600 mb-8">
            Our travel experts can help you choose the perfect destination based on your interests, time, and budget.
          </p>
          <Link 
            to="/contact" 
            className="inline-block bg-[#0e7c7c] hover:bg-[#0b5e5e] text-white px-8 py-4 rounded-full font-semibold text-lg transition-colors duration-200 shadow-lg"
          >
            Talk to a Travel Expert
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Destinations;